import { gql } from '@apollo/client';

export const CREATE_METRICS_MUTATOR = gql`
  mutation createMetricsMutator(
    $master_list: Boolean
    $metrics: [JSON]
    $user_email: String
    $group_id: String
    $company_id: String
    $include_emission_factors: Boolean
  ) {
    createMetrics(
      master_list: $master_list
      metrics: $metrics
      user_email: $user_email
      group_id: $group_id
      company_id: $company_id
      include_emission_factors: $include_emission_factors
    )
  }
`;

export const UPDATE_METRICS_MUTATOR = gql`
  mutation updateMetricsMutator(
    $master_list: Boolean
    $updated_metric: JSON
    $original_metric: JSON
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    updateMetric(
      master_list: $master_list
      updated_metric: $updated_metric
      original_metric: $original_metric
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const DELETE_METRICS_MUTATOR = gql`
  mutation deleteMetricsMutator(
    $group_id: String
    $company_id: String
    $metric_id: String
    $metric_group_id: String
    $metric_name: String
    $user_email: String
  ) {
    deleteMetric(
      group_id: $group_id
      company_id: $company_id
      metric_id: $metric_id
      metric_group_id: $metric_group_id
      metric_name: $metric_name
      user_email: $user_email
    )
  }
`;

export const DELETE_METRICS_WITH_EMISSION_FACTORS_MUTATOR = gql`
  mutation deleteMetricsMutator(
    $master_list: Boolean
    $metric_id: String
    $metric_group_id: String
    $metric_name: String
    $group_id: String
    $company_id: String
    $user_email: String
  ) {
    deleteMetricWithEmissionFactors(
      master_list: $master_list
      metric_id: $metric_id
      metric_group_id: $metric_group_id
      metric_name: $metric_name
      group_id: $group_id
      company_id: $company_id
      user_email: $user_email
    )
  }
`;

export const UNDELETE_METRICS_WITH_EMISSION_FACTORS_MUTATOR = gql`
  mutation undeleteMetricsMutator(
    $group_id: String
    $company_id: String
    $metric_id: String
    $metric_group_id: String
    $emission_factor_create: JSON
    $user_email: String
  ) {
    undeleteMetricWithEmissionFactors(
      group_id: $group_id
      company_id: $company_id
      metric_id: $metric_id
      metric_group_id: $metric_group_id
      emission_factor_create: $emission_factor_create
      user_email: $user_email
    )
  }
`;

export const SYNC_MASTER_LIST_METRICS = gql`
  mutation syncMasterListMetrics {
    syncMasterListMetrics
  }
`;
